import TagIcon from "assets/img/icons/common/Icon_Tags.svg";
import RecordChangeIcon from "assets/img/icons/common/Icon_Record_Change.svg";
import FieldUpdateIcon from "assets/img/icons/common/Icon_Field_Update.svg";
import IfElseIcon from "assets/img/icons/common/Icon_If_Else.svg";
import { FieldOptionsType } from "../components/Records/ComplexField/ComplexField";

export const SUPPORTED_EXTENSIONS = {
  // PDFs
  ".pdf": "application/pdf",

  // Microsoft Word
  ".doc": "application/msword",
  ".docx":
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",

  // WordPerfect
  ".wpd": "application/wordperfect",
  ".wp": "application/wordperfect",

  // Text files
  ".txt": "text/plain",
  ".text": "text/plain",
  ".rtf": "text/rtf",

  // Other document types
  ".odt": "application/vnd.oasis.opendocument.text",
  ".pages": "application/vnd.apple.pages",

  // Audio
  ".webm": [
    "video/webm",
    "audio/webm",
    "audio/webm;codecs=opus",
    "audio/wav",
    "audio/x-wav",
  ],
};

export const SUPPORTED_EXTENSION_VALUES = Object.values(
  SUPPORTED_EXTENSIONS
).flatMap((v) => v);

export const EMPTY_ID = "GC---EMPTY---ID";

const Email = { Name: "Email", APIName: "Email", FieldType: "Text" };
const Phone = { Name: "Phone", APIName: "Phone", FieldType: "Text" };
const Readable = { Name: "Readable", APIName: "Readable", FieldType: "Text" };
const Extension = {
  Name: "Extension",
  APIName: "Extension",
  FieldType: "Text",
};
const URL = { Name: "URL", APIName: "URL", FieldType: "Text" };
const Type = { Name: "Type", APIName: "Type", FieldType: "Text" };
const Description = {
  Name: "Description",
  APIName: "Description",
  FieldType: "Text",
};
const Primary = {
  Name: "Primary",
  APIName: "Primary",
  FieldType: "Toggle",
};
const Id = {
  Name: "ID",
  APIName: "id",
  FieldType: "Text",
};
const RecordName = {
  Name: "Record Name",
  APIName: "_RecordName",
  FieldType: "Text",
};
const ModuleAPIName = {
  Name: "Module API Name",
  APIName: "_ModuleAPIName",
  FieldType: "Text",
};
const File = { Name: "File", APIName: "File", FieldType: "Text" };
const AltText = { Name: "AltText", APIName: "AltText", FieldType: "Text" };
const Name = { Name: "Name", APIName: "Name", FieldType: "Text" };

export default class Constants {
  static MC_CLOUD_ID = "67926616148ff13ca9eb5216";
  static SUP_CLOUD_ID = "67ef18f591a6f4d2ec86b376";

  static SUPPORT_CLOUD_IDS = [this.MC_CLOUD_ID, this.SUP_CLOUD_ID];

  static ENVIRONMENT = {
    DEVELOPMENT: "dev",
    STAGING: "staging",
    PRODUCTION: "production",
  };

  static CALCULATED_FIELD_TYPES = [
    "Currency",
    "CurrencyInterval",
    "Number",
    "Percent",
    "Calculated",
  ];

  static RECORD_NAME_FIELDTYPES = [
    "Text",
    "LongText",
    "Number",
    "Percent",
    "Date",
    "Time",
    "DateTime",
    "Phone",
    "Email",
    "URL",
    "RichText",
    "Location",
  ];

  static DEFAULT_COLOR = "#DCDCDC";

  static API_URL = {
    DEVELOPMENT: "http://localhost:8080",
    STAGING: "https://apistaging.growthcloud.com",
    PRODUCTION: "https://api.growthcloud.com",
  };

  static THEME = {
    GREEN: "#26b058",
    BLUE: "#22a8e7",
    RED: "#e72222",
    MEDIUM: "#6e706f",
    PRIMARY: "#26b058",
    SECONDARY: "#212529",
    INDIGO: "#5603ad",
    SUPERLIGHT: "#e8edea",
  };

  static MODULE_NAMES = {
    DEAL_DESK: "desk",
    SUPPORTAL: "supportal",
    ACCOUNT: "account",
    CRM: "crm",
  };

  static MODULES = [
    {
      Slug: "crm",
      Name: "CRM",
      Icon: "mdi mdi-account-convert",
      Color: "#26b058",
      Default: true,
      Public: true,
    },
    /*{
      Slug: "desk",
      Name: "Deal Desk",
      Icon: "mdi mdi-view-dashboard",
      Color: "#26b058",
      Default: true,
      Public: true,
    },*/
    {
      Slug: "supportal",
      Name: "Supportal",
      Icon: "mdi mdi-lifebuoy",
      Color: "#3D9BE9",
      Default: false,
      Public: false,
    },
  ];

  static FIELDTYPES = {
    TEXT: "Text",
    LONG_TEXT: "LongText",
    NUMBER: "Number",
    PERCENT: "Percent",
    SINGLE_SELECT: "SingleSelect",
    MULTI_SELECT: "MultiSelect",
    DATE: "Date",
    TIME: "Time",
    DATE_TIME: "DateTime",
    TOGGLE: "Toggle",
    PHONE: "Phone",
    EMAIL: "Email",
    CURRENCY: "Currency",
    CALCULATED: "Calculated",
    CURRENCY_INTERVAL: "CurrencyInterval",
    SINGLE_REFERENCE: "SingleReference",
    MULTI_REFERENCE: "MultiReference",
    URL: "URL",
    MULTI_FILE: "MultiFile",
    SINGLE_FILE: "SingleFile",
    RICH_TEXT: "RichText",
    OBJECT: "Object",
    TAGS: "Tags",
    SUBITEM: "Subitem",
    MULTI_SUBITEM: "MultiSubitem",
    IMAGE: "Image",
    VIDEO: "Video",
    AUDIO: "Audio",
    LOCATION: "Location",
    FILTER: "Filter",
    COLOR: "Color",
  };

  static COMPLEX_FIELDS = {
    Email: [{ ...Email }, { ...Type }, { ...Description }, { ...Primary }],
    Phone: [
      { ...Phone },
      { ...Extension },
      { ...Type },
      { ...Description },
      { ...Primary },
    ],
    URL: [{ ...URL }, { ...Type }, { ...Description }, { ...Primary }],
    MultiReference: [{ ...Id }, { ...RecordName }, { ...ModuleAPIName }],
    SingleFile: [{ ...Id }, { ...File }, { ...AltText }, { ...Name }],
    Location: [{ ...Readable }, { ...Description }, { ...Type }],
    Image: [{ ...File }, { ...Name }, { ...AltText }],
    Audio: [{ ...File }, { ...Name }],
    Video: [{ ...File }, { ...Name }],
  };

  static COMPLEX_FIELDS_MAP = {
    Email: { ...Email },
    Phone: { ...Phone },
    Extension: { ...Extension },
    URL: { ...URL },
    Type: { ...Type },
    Description: { ...Description },
    Primary: { ...Primary },
    Id: { ...Id },
    RecordName: { ...RecordName },
    ModuleAPIName: { ...ModuleAPIName },
    Name: { ...Name },
    File: { ...File },
    AltText: { ...AltText },
  };

  static MAPPING_ICONS = {
    Identifier: "mdi mdi-identifier",
    Value: "mdi mdi-alphabetical-variant",
    Dynamic: "mdi mdi-xml",
    Action: "mdi mdi-sitemap",
    ActionID: "mdi mdi-sitemap",
  };

  static ACTION_DESCRIPTIONS = {
    "record-create-update": "Import & Update Records",
  };

  static UNFILTERABLE_FIELDS = [
    Constants.FIELDTYPES.SINGLE_FILE,
    Constants.FIELDTYPES.MULTI_FILE,
    Constants.FIELDTYPES.IMAGE,
  ];

  static TENANT_MODULE_TEMPLATES = {
    RECORD_LIST_VIEW: "RecordListView",
    RECORD_DETAIL_VIEW: "RecordDetailView",
    SUB_MODULES: "RecordDetailViewSubModules",
  };

  static FILTERTYPES = {
    EQUALS: {
      Name: "is",
      Value: "equals",
    },
    NOT_EQUALS: {
      Name: "isn't",
      Value: "not-equals",
    },
    GREATER_THAN: {
      Name: ">",
      Value: "gt",
    },
    GREATER_THAN_EQUALS: {
      Name: ">=",
      Value: "gte",
    },
    LESS_THAN: {
      Name: "<",
      Value: "lt",
    },
    LESS_THAN_EQUALS: {
      Name: "<=",
      Value: "lte",
    },
    CONTAINS: {
      Name: "contains",
      Value: "contains",
    },
    BETWEEN: {
      Name: "between",
      Value: "between",
    },
    NOT_BETWEEN: {
      Name: "not between",
      Value: "not-between",
    },
    NOT_EMPTY: {
      Name: "is not empty",
      Value: "is-not-empty",
    },
    EMPTY: {
      Name: "is empty",
      Value: "is-empty",
    },
  };

  static CURRENCY_INTERVALS = {
    SECOND: "sec",
    MINUTE: "min",
    HOUR: "hr",
    DAY: "day",
    WEEK: "wk",
    MONTH: "mo",
    QUARTER: "qtr",
    YEAR: "yr",
  };

  static KEYS = {
    ESCAPE: 27,
    ENTER: 13,
    BACKSPACE: 8,
    TAB: 9,
    DELETE: 46,
    SPACE: 32,
    LEFT: 37,
    RIGHT: 39,
  };

  static EMAIL_TYPE_OPTIONS: FieldOptionsType = [
    { label: "Personal", value: "Personal", color: "#8DC6DF" },
    { label: "Work", value: "Work", color: "#F1E696" },
    { label: "Other", value: "Other", color: "#B4B3AE" },
  ];

  static URL_TYPE_OPTIONS: FieldOptionsType = [
    { label: "Website", value: "Website", color: "#B4E2E5" },
    { label: "Support", value: "Support", color: "#B4B3AE" },
    { label: "LinkedIn", value: "LinkedIn", color: "#88C8E0" },
    { label: "Facebook", value: "Facebook", color: "#4267B2" },
    { label: "Instagram", value: "Instagram", color: "#E1306C" },
    { label: "TikTok", value: "TikTok", color: "#ff0050" },
    { label: "Blog", value: "Blog", color: "#EDDBA8" },
    { label: "Other", value: "Other", color: "#B4B3AE" },
  ];

  static PHONE_TYPE_OPTIONS: FieldOptionsType = [
    { label: "Mobile", value: "Mobile", color: "#9AD998" },
    { label: "Business", value: "Business", color: "#F1E696" },
    { label: "Personal", value: "Personal", color: "#8DC6DF" },
    { label: "Other", value: "Other", color: "#B4B3AE" },
  ];

  //(#D91E18, #C0392B, #9B111)

  static LOCATION_TYPE_OPTIONS: FieldOptionsType = [
    { label: "Corporate", value: "Corporate", color: "#0073B7" },
    { label: "Branch", value: "Branch", color: "#8B5E3C" },
    { label: "Field", value: "Field", color: "#219b4e" },
    { label: "Postal", value: "Postal", color: "#8B8B8B" },
    { label: "Billing", value: "Billing", color: "#ff0d3d" },
  ];

  // USE lowercase.
  static COSMOS_KEYWORDS = ["from"];

  static NUMBER_TYPES = ["Currency", "CurrencyInterval", "Percent", "Number"];

  static GOOGLE_MAPS_KEY = "AIzaSyDJsRqbo3lE5ICJrseFXtJYJwLGZlj6lzM";

  static FILETYPES = {
    IMAGE: [
      ".bmp",
      ".jpeg",
      ".jpg",
      ".png",
      ".ps",
      ".psd",
      ".svg",
      ".tif",
      ".tiff",
      ".gif",
      ".io",
      ".ai",
      "image/*",
    ],
    VIDEO: [
      ".3g2",
      ".3gp",
      ".avi",
      ".flv",
      ".h264",
      ".m4v",
      ".mkv",
      ".mov",
      ".mp4",
      ".mpg",
      ".mpeg",
      ".rm",
      ".swf",
      ".vob",
      ".wmv",
      "video/*",
    ],
    AUDIO: [
      ".mp3",
      ".mpa",
      ".wav",
      ".wma",
      ".wpl",
      ".aif",
      ".cda",
      ".webm",
      ".mtm",
      ".weba",
      ".flac",
      ".midi",
      ".m4a",
      ".aria",
      ".aa3",
      ".wave",
      ".aac",
      ".mpga",
      "audio/*",
    ],
    TEXT: ["text/plain", ".json"],
    DATA: [
      ".csv",
      "text/csv",
      ".xlsx",
      ".xls",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ],
  };

  static WORKFLOW_TRIGGERS = {
    MANUAL_FILE_IMPORT: {
      Type: "manual-file-import",
      Name: "File Upload",
      Description: "When a CSV, Excel, or JSON file is uploaded",
      Icon: "mdi mdi-upload",
    },
  };

  static WORKFLOW_ACTIONS_DEFAULTS = {
    ActionID: "",
    Name: "",
    Description: "",
  };

  static DEFAULT_QUERY_FIELDS = ["id", "_RecordName", "Created"];

  static WORKFLOW_ACTIONS = {
    VALIDATE: {
      Hide: () => true,
      GetName: (moduleName: string) =>
        `Validate ${moduleName || ""} Record Entries`,
      GetDescription: (moduleName: string) =>
        `In the ${
          moduleName || "selected"
        } data source, validate the records provided in the file.`,
      Icon: "mdi mdi-file-document-check",
      ModuleAPIName: "",
      Type: "validate",
      FieldMapping: [],
    },
    RECORD_CREATE_UPDATE: {
      Hide: (actions: any) => false,
      ActionName: "Import & Update Records",
      ActionDescription:
        "In a selected data source, records will be imported using the provided file.",

      Icon: RecordChangeIcon,
      VectorIcon: true,
      ModuleAPIName: "",
      Type: "record-create-update",
      AvailableToFutureActions: true,
      FieldMapping: [],
    },
    RECORD_UPDATE_TAGS: {
      // Requires a prev action of record-create-update; There must be records to apply tags to.
      Hide: (actions: any) =>
        !actions?.map((a: any) => a?.Type)?.includes("record-create-update"),
      ActionName: "Add/Remove Tags to Imported Records",
      ActionDescription:
        "Using a previous Import action's records, add/remove tags to them.",
      Icon: TagIcon,
      VectorIcon: true,
      Type: "record-update-tags",
      ReferencedAction: null,
      Tags: [],
      TagsAction: "add",
    },
    RECORD_UPDATE_FIELDS: {
      Hide: (actions: any) =>
        !actions?.map((a: any) => a?.Type)?.includes("record-create-update"),
      ActionName: "Update Fields in Imported Records",
      ActionDescription:
        "Using a previous Import action's records, update specified fields in them.",
      Icon: FieldUpdateIcon,
      VectorIcon: true,
      Type: "record-update-fields",
      ReferencedAction: null,
      DataToUpdate: {},
    },
    IF_ELSE: {
      Hide: (actions: any) => false,
      ActionName: "If / Else Statement",
      ActionDescription:
        "Decide what action is next based on the result of a previous action",
      Icon: IfElseIcon,
      VectorIcon: true,
      Type: "if-else-case",
      ReferencedAction: null,
      Evaluation: {}, // The query/condition
      TrueActions: [], // Nest actions inside here
      FalseActions: [], // Nest actions inside here
    },
    RECORD_CREATE_SUBITEMS: {
      Hide: (actions: any) => true,
      ActionName: "Record Create Subitems",
      ActionDescription: "Import subitems into a record's multisubitem field.",

      Icon: RecordChangeIcon,
      VectorIcon: true,
      ModuleAPIName: "",
      Type: "record-create-update-subitems",
      AvailableToFutureActions: false,
      FieldMapping: [],
    },
  };

  static SUB_DEFAULT_FIELDS = (readonly = false) => [
    {
      Name: "id",
      APIName: "id",
      ReadOnly: true,
      FieldType: "Text",
      SystemField: true,
      Unique: true,
    },
    {
      APIName: "Created",
      Name: "Created",
      ReadOnly: true,
      FieldType: "DateTime",
      SystemField: true,
    },
    {
      APIName: "LastUpdated",
      Name: "Modified",
      ReadOnly: true,
      FieldType: "DateTime",
      SystemField: true,
    },
    {
      APIName: "CreatedBy",
      Name: "Created By",
      ReadOnly: true,
      FieldType: "SingleReference",
      SourcesList: "Tenant.Modules.Contacts",
      SystemField: true,
    },
    {
      APIName: "LastUpdatedBy",
      Name: "Modified By",
      ReadOnly: true,
      FieldType: "SingleReference",
      SourcesList: "Tenant.Modules.Contacts",
      SystemField: true,
    },
    {
      APIName: "Tags",
      Name: "Tags",
      ReadOnly: readonly,
      FieldType: "Tags",
      SystemField: true,
    },
  ];

  static BASIC_DEFAULT_FIELDS = () => [
    {
      APIName: "Created",
      Name: "Created",
      ReadOnly: true,
      FieldType: "DateTime",
      SystemField: true,
    },
    {
      APIName: "LastUpdated",
      Name: "Modified",
      ReadOnly: true,
      FieldType: "DateTime",
      SystemField: true,
    },
    {
      APIName: "CreatedBy",
      Name: "Created By",
      ReadOnly: true,
      FieldType: "SingleReference",
      SourcesList: "Tenant.Modules.Contacts",
      SystemField: true,
    },
    {
      APIName: "LastUpdatedBy",
      Name: "Modified By",
      ReadOnly: true,
      FieldType: "SingleReference",
      SourcesList: "Tenant.Modules.Contacts",
      SystemField: true,
    },
  ];

  static DEFAULT_FIELDS: any = (readonly = false) => [
    {
      Name: "id",
      APIName: "id",
      ReadOnly: true,
      FieldType: "Text",
      SystemField: true,
      Unique: true,
    },
    {
      APIName: "_RecordName",
      Name: "Record Name",
      ReadOnly: true,
      FieldType: "Text",
      SystemField: true,
    },
    ...this.BASIC_DEFAULT_FIELDS(),
    {
      APIName: "Tags",
      Name: "Tags",
      ReadOnly: false,
      FieldType: "Tags",
      SystemField: true,
      // Add sources list based off module
    },
    {
      APIName: "_RemoteSystems",
      Name: "Remote Systems",
      ReadOnly: readonly,
      FieldType: "MultiSubitem",
      SystemField: true,
      SubitemFields: [
        {
          Name: "Remote Name",
          APIName: "Name",
          FieldType: "Text",
          SubitemParent: "_RemoteSystems",
        },
        {
          Name: "Remote System ID",
          APIName: "RemoteSystemID",
          FieldType: "Text",
          SubitemParent: "_RemoteSystems",
        },
        {
          Name: "Publishing Cloud",
          APIName: "RemoteID",
          FieldType: "Text",
          SubitemParent: "_RemoteSystems",
        },
        {
          Name: "URL",
          APIName: "URL",
          FieldType: "URL",
          SubitemParent: "_RemoteSystems",
        },
        {
          Name: "Remote Created",
          APIName: "RemoteCreated",
          FieldType: "DateTime",
          SubitemParent: "_RemoteSystems",
        },
        {
          Name: "Remote Modified",
          APIName: "RemoteModified",
          FieldType: "DateTime",
          SubitemParent: "_RemoteSystems",
        },
        {
          Name: "Remote Module",
          APIName: "RemoteModule",
          FieldType: "Text",
          SubitemParent: "_RemoteSystems",
        },
        {
          Name: "Shared Owner",
          APIName: "RemoteOwner",
          FieldType: "SingleReference",
          SourcesList: "Tenant.Modules.Contacts",
          SubitemParent: "_RemoteSystems",
          IdOnly: true,
        },
        {
          Name: "Metadata",
          APIName: "Metadata",
          FieldType: "Object",
          Protected: true,
          Default: true,
          SubitemParent: "_RemoteSystems",
        },
      ],
      Protected: false,
      Query: [
        {
          QueryField: "_RemoteSystems",
          Query: {
            Fields: [
              "Name",
              "RemoteSystemID",
              "RemoteID",
              "RemoteModule",
              "URL",
              "RemoteCreated",
              "RemoteModified",
              "Tags",
            ],
            Filters: [],
            _SelectedLayout: "572b1c4f-a086-4977-afe2-6e0630be0fdb",
          },
        },
      ],
      TableLayouts: [
        {
          Name: "Main Layout",
          Fields: [
            "Name",
            "RemoteSystemID",
            "RemoteID",
            "RemoteModule",
            "URL",
            "RemoteCreated",
            "RemoteModified",
            "Tags",
          ],
          id: "572b1c4f-a086-4977-afe2-6e0630be0fdb",
        },
      ],
      Prefills: [],
      SavedFilters: [],
    },
  ];

  static DASHBOARD_COLOR_THEMES: Record<string, string[]> = {
    Cynosure: [
      "#00Bceb",
      "#0d274d",
      "#0051af",
      "#74BF4B",
      "#FBAB2C",
      "#414344",
      "#CF2030",
      "#232F3E",
      "#FF9900",
      "#047FAD",
      "#E2E2E2",
    ],
    Neon: [
      "#FF5733",
      "#33FF57",
      "#5733FF",
      "#FF33A1",
      "#33A1FF",
      "#A1FF33",
      "#FF336E",
      "#336EFF",
      "#FFA133",
      "#A133FF",
      "#3347FF",
    ],
    Default: [
      "#26B058",
      "#6c5de2",
      "#22a8e7",
      "#bdc9c2",
      "#4AD87E",
      "#11CDEF",
      "#FFC5C1",
      "#C8F3D8",
      "#1A7B3D",
      "#E8EDEA",
      "#2bffc6",
      "#e74c3c",
      "#f39c12",
      "#34495e",
    ],
    Random: [
      "#3498db",
      "#2ecc71",
      "#e74c3c",
      "#f39c12",
      "#1abc9c",
      "#9b59b6",
      "#34495e",
      "#16a085",
      "#d35400",
      "#27ae60",
      "#8e44ad",
      "#c0392b",
      "#2980b9",
      "#e67e22",
      "#FF5733",
      "#33FF57",
      "#5733FF",
      "#FF33E6",
      "#33E6FF",
      "#E6FF33",
      "#FF3366",
      "#3366FF",
      "#66FF33",
      "#FF6633",
      "#33FF66",
      "#6633FF",
      "#FF9966",
      "#9966FF",
    ],
  };

  /**
   * An array which contains the schemas of some default modules that are not required to be saved
   * on the Tenant Schema
   */
  static DEFAULT_MODULES: any[] = [
    {
      Name: "Recycle Bin",
      APIName: "DeletedRecords",
      Protected: true,
      Default: true,
      Templates: {
        RecordListView: {
          Fields: ["Name", "DeletionDate", "DataSource"],
        },
        RecordDetailView: {
          PageTitle: "{{Name}}",
          Layouts: [],
        },
        QuickSearch: ["Name", "DataSource"],
      },
      Fields: [
        {
          Name: "Deletion Date",
          APIName: "DeletionDate",
          FieldType: "Date",
          DefaultValue: "",
          Protected: true,
          Default: true,
        },
        {
          Name: "Record Data",
          APIName: "RecordData",
          FieldType: "Object",
          Protected: true,
          Default: true,
          ReadOnly: true,
        },
        {
          Name: "Name",
          APIName: "Name",
          FieldType: "Text",
          Protected: true,
          Default: true,
          ReadOnly: true,
        },
        {
          Name: "Data Source",
          APIName: "DataSource",
          FieldType: "SingleSelect",
          DefaultValue: "",
          SourcesList: [],
          Default: true,
          ReadOnly: true,
        },
        {
          APIName: "Created",
          Name: "Deleted",
          ReadOnly: true,
          FieldType: "DateTime",
          SystemField: true,
        },
        {
          APIName: "CreatedBy",
          Name: "Deleted By",
          ReadOnly: true,
          FieldType: "SingleReference",
          SourcesList: "Tenant.Modules.Contacts",
          SystemField: true,
        },
      ],
    },
    {
      Name: "Brie Cost Tracker",
      APIName: "BrieCostTracker",
      Default: true,
      Protected: true,
      Fields: [
        {
          Name: "Record Name",
          APIName: "RecordName",
          FieldType: "Text",
          Protected: true,
          ReadOnly: true,
        },
        {
          Name: "Owner",
          APIName: "Owner",
          FieldType: "Text",
          ReadOnly: true,
          Protected: true,
        },
        // Models
        {
          Name: "gpt-4o-mini",
          APIName: "gpt-4o-mini",
          ReadOnly: true,
          FieldType: "Text",
          Protected: true,
        },
        {
          Name: "gpt-4o",
          APIName: "gpt-4o",
          ReadOnly: true,
          FieldType: "Text",
          Protected: true,
        },
        {
          Name: "o3-mini",
          APIName: "o3-mini",
          ReadOnly: true,
          FieldType: "Text",
          Protected: true,
        },
        {
          Name: "Gemini Flash 2.0",
          APIName: "gemini-2-0-flash",
          ReadOnly: true,
          FieldType: "Text",
          Protected: true,
        },
        {
          Name: "Gemini Flash 2.5",
          APIName: "gemini-2-5-flash",
          ReadOnly: true,
          FieldType: "Text",
          Protected: true,
        },
        {
          Name: "Claude 3.7",
          APIName: "claude-3-7-sonnet-latest",
          ReadOnly: true,
          FieldType: "Text",
          Protected: true,
        },
        {
          Name: "Claude 3.5",
          APIName: "claude-3-5-haiku-latest",
          ReadOnly: true,
          FieldType: "Text",
          Protected: true,
        },
        {
          APIName: "Created",
          Name: "Created",
          ReadOnly: true,
          FieldType: "DateTime",
          SystemField: true,
        },
      ],
    },
    {
      Name: "People",
      APIName: "People",
      Default: true,
      Protected: true,
      Fields: [
        {
          Name: "Record Name",
          APIName: "_RecordName",
          FieldType: "Text",
          Protected: true,
          ReadOnly: true,
        },
        {
          Name: "Name",
          APIName: "Name",
          FieldType: "Text",
          Protected: true,
          ReadOnly: true,
        },
        {
          Name: "Phone",
          APIName: "Phone",
          FieldType: "Text",
          Protected: true,
          ReadOnly: true,
        },
        {
          Name: "Email",
          APIName: "PrimaryContactEmail",
          FieldType: "Text",
          Protected: true,
          ReadOnly: true,
        },
        {
          Name: "Status",
          APIName: "Status",
          FieldType: "SingleSelect",
          DefaultValue: "",
          SourcesList: [
            {
              Name: "Active",
              Value: "Active",
              Color: "#26B058",
            },
            {
              Name: "Pending",
              Value: "Pending",
              Color: "#FA5454",
            },
          ],
          ReadOnly: false,
        },
        {
          Name: "Created",
          APIName: "Created",
          ReadOnly: true,
          FieldType: "DateTime",
          SystemField: true,
        },
        {
          Name: "Modified",
          APIName: "LastUpdated",
          ReadOnly: true,
          FieldType: "DateTime",
          SystemField: true,
        },
        {
          Name: "Modified By",
          APIName: "LastUpdatedBy",
          ReadOnly: true,
          FieldType: "SingleReference",
          SourcesList: "Tenant.Modules.Contacts",
          SystemField: true,
        },
        {
          Name: "Tester",
          APIName: "Tester",
          FieldType: "Toggle",
          TrueDisplayName: "Yes",
          FalseDisplayName: "No",
        },
      ],
      Templates: {
        QuickSearch: ["Name", "Phone", "PrimaryContactEmail"],
      },
    },
    {
      Name: "Tenants",
      APIName: "Tenants",
      Default: true,
      Protected: true,
      Fields: [
        {
          Name: "Record Name",
          APIName: "_RecordName",
          FieldType: "Text",
          Protected: true,
          ReadOnly: true,
        },
        {
          Name: "Name",
          APIName: "Name",
          FieldType: "Text",
          Protected: true,
          ReadOnly: true,
        },
        {
          Name: "Partially Deleted?",
          APIName: "Deleted",
          FieldType: "Toggle",
          Protected: true,
          ReadOnly: true,
          TrueDisplayName: "Yes",
          FalseDisplayName: "False",
        },
        {
          Name: "Primary Address",
          APIName: "BillingAddress",
          FieldType: "Text",
          Protected: true,
          ReadOnly: true,
        },
        {
          Name: "Email",
          APIName: "BillingContactEmail",
          FieldType: "Text",
          Protected: true,
          ReadOnly: true,
        },
        {
          Name: "Cloud UUID",
          APIName: "_id",
          FieldType: "Text",
          Protected: true,
          ReadOnly: true,
        },
        {
          Name: "Cloud Tier",
          APIName: "Tier",
          FieldType: "Text",
          Protected: true,
          ReadOnly: true,
        },
        {
          Name: "Cloud Database",
          APIName: "DatabaseName",
          FieldType: "Text",
          Protected: true,
          ReadOnly: true,
        },
        {
          Name: "Azure Storage Container",
          APIName: "StorageContainerName",
          FieldType: "Text",
          Protected: true,
          ReadOnly: true,
        },
        {
          Name: "Created",
          APIName: "Created",
          ReadOnly: true,
          FieldType: "DateTime",
          SystemField: true,
        },
      ],
      Templates: {
        QuickSearch: ["Name"],
      },
    },
    {
      Name: "Shared Documents",
      APIName: "SharedDocuments",
      Protected: true,
      Default: true,
      DataWarehouse: "",
      Fields: [
        {
          Name: "Record Name",
          APIName: "_RecordName",
          FieldType: "Text",
          Protected: true,
          ReadOnly: true,
        },
        {
          Name: "Document ID",
          APIName: "DocumentID",
          FieldType: "SingleReference",
          SourcesList: "Tenant.Modules.Documents",
          Protected: true,
          ReadOnly: true,
          Default: true,
        },
        {
          Name: "Authentication",
          APIName: "Authentication",
          FieldType: "SingleSelect",
          ReadOnly: true,
          SourcesList: [
            {
              Name: "Password",
              Value: "Password",
            },
            {
              Name: "GC User",
              Value: "GC User",
            },
            { Name: "None", Value: "None" },
          ],
          Protected: true,
          Default: true,
        },
        {
          Name: "Password",
          APIName: "Password",
          FieldType: "Text",
          ReadOnly: true,
          Protected: true,
          Default: true,
        },
        {
          Name: "Created",
          APIName: "Created",
          ReadOnly: true,
          FieldType: "DateTime",
          SystemField: true,
        },
        {
          Name: "Last Updated",
          APIName: "LastUpdated",
          ReadOnly: true,
          FieldType: "DateTime",
          SystemField: true,
        },
      ],
      Templates: {
        QuickSearch: ["DocumentID"],
      },
    },
    {
      Name: "AI Models",
      APIName: "AIModels",
      GlobalModule: true,
      Default: true,
      Protected: true,
      Fields: [
        {
          Name: "Model Name",
          APIName: "ModelName",
          FieldType: "Text",
          Protected: true,
          Default: true,
        },
        {
          Name: "Model API Name",
          APIName: "ModelAPIName",
          FieldType: "Text",
          Protected: true,
          Default: true,
        },
        {
          Name: "Company",
          APIName: "Company",
          FieldType: "Text",
          Protected: true,
          Default: true,
        },
        {
          Name: "Status",
          APIName: "Status",
          FieldType: "SingleSelect",
          Protected: true,
          Default: true,
          SourcesList: [
            { Value: "Available", Name: "Available", Color: "#10B981" },
            { Value: "Unavailable", Name: "Unavailable", Color: "#EF4444" },
            { Value: "Degraded", Name: "Degraded", Color: "#F59E0B" },
          ],
        },
        {
          Name: "Description",
          APIName: "Description",
          FieldType: "LongText",
          Protected: true,
          Default: true,
        },
        {
          Name: "Image",
          APIName: "Image",
          FieldType: "Image",
          Presentation: "Logo",
          Public: true,
          Protected: true,
          Default: true,
        },
        ...Constants.BASIC_DEFAULT_FIELDS(),
      ],
      Templates: {},
    },
  ];

  /**
   * Cost per model (OpenAI)
   */
  static MODELS_COST = {
    "gpt-4o-mini": {
      output: 0.0000006,
      input: 0.00000015,
    },
    "gpt-4o": {
      output: 0.00001,
      input: 0.0000025,
    },
    "o3-mini": {
      input: 0.0000011,
      output: 0.0000044,
    },
    "gemini-2-0-flash": {
      output: 0.0000004,
      input: 0.0000001,
    },
    "gemini-2-5-flash": {
      output: 0.0000006,
      input: 0.00000015,
    },
    "claude-3-7-sonnet-latest": {
      output: 0.000015,
      input: 0.000003,
    },
    "claude-3-5-haiku-latest": {
      output: 0.000004,
      input: 0.0000008,
    },
  };

  // Supportal Related Constants
  // GC Engineering Cloud ID
  static SPRINTS_TENANT_ID = "6511e226c480fc209698cd6e";
  static SPRINTS_ISSUES_API_NAME = "SPRINTIssues";

  static SPRINT_ISSUES_SCHEMA: any = {
    Name: "SPRINT Issues",
    APIName: this.SPRINTS_ISSUES_API_NAME,
    Fields: [
      {
        Name: "Title",
        APIName: "Title",
        FieldType: "Text",
        Required: true,
      },
      {
        Name: "Description",
        APIName: "Description",
        FieldType: "RichText",
      },
      {
        Name: "Type",
        APIName: "Type",
        FieldType: "SingleSelect",
        DefaultValue: "Task",
        Required: true,
        SourcesList: [
          {
            Name: "Bug",
            Value: "Bug",
            Color: "#ff4747",
            id: "15b2b352-4d5e-49dc-b50f-0c3be7d8c870",
          },
          {
            Name: "Task",
            Value: "Task",
            Color: "#0f8bff",
            id: "0d3a6373-03fc-4b93-befd-72d7c23c4dab",
          },
        ],
      },
      {
        Name: "Sprint",
        APIName: "Sprint",
        FieldType: "SingleReference",
        SourcesList: `${this.SPRINTS_TENANT_ID}.Modules.SPRINTSprints`,
        RecordSummary: true,
        RecordSummaryFields: {
          SPRINTSprints: {
            Fields: ["Current", "Project", "Related"],
            summaryPresentation: "RegularField",
          },
        },
        GcUsers: false,
        Hierarchical: false,
      },
      {
        Name: "Status",
        APIName: "Status",
        FieldType: "SingleSelect",
        DefaultValue: "Backlog",
        Required: true,
        SourcesList: [
          {
            Name: "Backlog",
            Value: "Backlog",
            Color: "#e8edea",
            id: "5b68a1bc-7428-4fb5-88a2-9399706b9870",
          },
          {
            Name: "In Progress",
            Value: "In Progress",
            Color: "#5cceff",
            id: "1131a7cc-3dc5-44e0-86a1-a58bb224a9e0",
          },
          {
            Name: "In Review",
            Value: "In Review",
            Color: "#ffe27a",
            id: "3fd3dd0c-52e1-4623-8fe1-509ffd7bd9b2",
          },
          {
            Name: "Done",
            Value: "Done",
            Color: "#00e05a",
            id: "291dd735-7fc3-4f19-87b5-c6871daa1dca",
          },
        ],
      },
      {
        Name: "Assigned To",
        APIName: "AssignedTo",
        FieldType: "MultiReference",
        SourcesList: `${this.SPRINTS_TENANT_ID}.Modules.Contacts`,
        RecordSummaryFields: {},
        GcUsers: true,
      },
      {
        Name: "Developer Notes",
        APIName: "DeveloperNotes",
        FieldType: "RichText",
      },
      {
        Name: "Project",
        APIName: "Project",
        FieldType: "SingleReference",
        Hierarchical: false,
        SourcesList: [`${this.SPRINTS_TENANT_ID}.Modules.SPRINTProjects`],
        RecordSummaryFields: {},
        GcUsers: false,
        // Change to true on production
        Required: false,
      },
    ],
    Default: false,
    Protected: false,
  };
}
